import { render, staticRenderFns } from "./ClientRoleForm.vue?vue&type=template&id=e5ceeade&scoped=true&"
import script from "./ClientRoleForm.vue?vue&type=script&lang=js&"
export * from "./ClientRoleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ceeade",
  null
  
)

export default component.exports